export default "__VITE_ASSET__12239bbf__"